import { useMemo } from 'react';

/**
 * 畫布圖層的放大補償 transform。
 *
 * 頁面在區間放大／四格放大時是被放大的，畫布圖層必須反向縮放並位移回去，
 * 才會貼齊底下的教材。原本這段算式寫死在 FabricCanvas 裡，
 * 雷射筆的 overlay 需要完全相同的補償，因此抽出來共用 —— 兩層永遠對齊，
 * 之後放大邏輯若有調整也只有一處要改。
 */
export const useCanvasViewTransform = ({
  width,
  height,
  scale,
  offsetX,
  offsetY,
  fullWidthScale
}) =>
  useMemo(() => {
    const scaleGapX = (width * scale - width) / 2;
    const scaleGapY = (height * scale - height) / 2;
    const nextScale = 1 / scale;
    const nextOffsetX = -(offsetX / fullWidthScale + scaleGapX / fullWidthScale);
    const nextOffsetY = -(offsetY + scaleGapY);

    return `scaleX(${nextScale}) scaleY(${nextScale}) translate(${nextOffsetX}px,${nextOffsetY}px)`;
  }, [width, height, scale, offsetX, offsetY, fullWidthScale]);
